import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldArray } from 'formik';
import config from '../config';

/**
 * @param {function} onChange
 * @param {boolean} checked
 * @param {string} label
 * @returns {React.Component}
 */
const Checkbox = ({ onChange, checked, label, scheduled, onLeave, disabled }) => {
  const scheduledLabel = scheduled > 0 ?
    (<small className="employees-list__capacity u-color-mute">{scheduled} uur gepland</small>) :
    null;

  const labelClassname = checked ? 'font-bold' : '';

  return (
    <div>
      <input
        type="checkbox"
        name="employees"
        id={`employees-${label.toLowerCase()}`}
        disabled={typeof disabled !== 'undefined' ? disabled : false}
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={`employees-${label.toLowerCase()}`} className={onLeave ? 'strike-through' : ''}>
        <FontAwesomeIcon icon="check" />
        <span className={labelClassname}>{label}</span>
        {scheduledLabel}
      </label>
    </div>
  );
};

/**
 * @param {object} arrayHelpers
 * @param {object} values
 * @returns {array}
 */
const employeesListComponent = (arrayHelpers, employees, employeesList) => {
  return employeesList.map((employee) => {
    const { id, fullname } = employee;
    const isChecked = employees.indexOf(id) >= 0;

    if (fullname === 'Anoniem' || fullname === 'OrangeTalent') {
      return null;
    }

    if (!fullname) {
      return null;
    }

    return (
      <div className="employees-list__employee" key={id}>
        <Checkbox
          checked={isChecked}
          label={fullname}
          scheduled={employee.scheduledHours}
          onLeave={employee.on_leave}
          disabled={!config.writeAccess}
          onChange={e => {
            if (e.target.checked) {
              arrayHelpers.push(id);
            } else {
              const index = employees.indexOf(id);
              arrayHelpers.remove(index);
            }
          }}
        />
      </div>
    );
  });
};

/**
 * Create a field array with employee checkboxes
 *
 * @param {object} values
 * @returns {React.Component}
 */
export default ({ employees, employeesList }) => {
  return (
    <FieldArray
      name="employees"
      render={arrayHelpers => (
        <div className="employees-list">
          {employeesListComponent(arrayHelpers, employees, employeesList)}
        </div>
      )}
    />
  );
};



// WEBPACK FOOTER //
// ./src/forms/ShiftEmployeesList.js